import { Component, Input, OnInit } from '@angular/core';

import { DashboardLoanCategory } from '../services/dashboard/dashboard.service';

@Component({
  selector: 'ld-my-loan-group',
  template: `
    <div *ngIf="shouldShowLoanGroup()">
      <div *ngIf="!hideDivider" class="dropdown-divider"></div>
      <div class="text-cursor" [class.open]="showGroupDetail">
        <div class="stuff" (click)="toggleGroup()">
          <i class="fa fa-chevron-down" *ngIf="isOnSidePanel"></i>
          <i class="fa fa-file-text" *ngIf="isOnSidePanel"></i>
          {{ groupName }}
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  `
})

export class MyLoanGroupComponent implements OnInit {
  @Input() private hideDivider: boolean = false;
  @Input() private loanCategory: DashboardLoanCategory;
  @Input() private isOnSidePanel: boolean = false;

  private groupName: string;
  private groupLoanLength: number;
  private showGroupDetail: boolean = false;

  ngOnInit(): void {
    this.groupName = this.loanCategory.label;
    this.groupLoanLength = this.loanCategory.loans.length;
  }

  shouldShowLoanGroup(): boolean {
    return !this.isOnSidePanel || (this.isOnSidePanel && this.groupLoanLength > 0);
  }

  private toggleGroup(): void {
    this.showGroupDetail = !this.showGroupDetail;
  }
}
